var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wordhomw-wrap"},[_c('div',{staticClass:"v-note-wrapper markdown-body shadow"},[_c('h2',[_c('a'),_vm._v("数据库配置")]),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("连接非mysql数据库注意事项")])]),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("集成其他数据库报错怎么办？")])])])])])
}]

export { render, staticRenderFns }